module.exports = __webpack_public_path__ + "static/media/nosotros05M.a5288960.jpg";